import { DataModel, DataModelBuilder, isSameData,
  isSameList, SerializationContext, SerializedData } from '../dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { ScheduleTimeSpan } from './schedule-time-span.js';
import { TimeOfDay } from './time-of-day.js';
import { ISchedule } from '../../contracts/schedule.js';
import { DayOfWeek } from './day-of-week.js';
import { fromEnumAsString } from '../../serialization/enum-utils.js';

export class WeeklyScheduleDay extends DataModel implements ISchedule {
  static readonly TYPE_ID: string = '42e4b37f536e4924ac4c0cbb2f0c6281';

  constructor(
    public readonly dayOfWeek: DayOfWeek,
    public readonly times: ScheduleTimeSpan[],
    public readonly closed: boolean = false,
  ) {
    super();
  }

  get $typeId(): string {
    return WeeklyScheduleDay.TYPE_ID;
  }

  get hasAnyHoursDefined() {
    return !this.closed && this.times.length !== 0;
  }

  static nineToFive(dayOfWeek: DayOfWeek): WeeklyScheduleDay {
    return new WeeklyScheduleDay(
        dayOfWeek,
        [new ScheduleTimeSpan(new TimeOfDay(9, 0), new TimeOfDay(17, 0))],
        false,
    );
  }

  static closed(dayOfWeek: DayOfWeek): WeeklyScheduleDay {
    return new WeeklyScheduleDay(
        dayOfWeek,
        [],
        true,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): WeeklyScheduleDay {
    return new WeeklyScheduleDay(
        MapUtils.get<DayOfWeek>(map, 'dayOfWeek'),
        MapUtils.getList<ScheduleTimeSpan>(map, 'times', (value) =>
          context.fromData<ScheduleTimeSpan>(value as SerializedData)),
        MapUtils.get<boolean>(map, 'closed'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'dayOfWeek': fromEnumAsString(this.dayOfWeek),
      'closed': this.closed,
      'times': this.times.map((t) => context.toData(t)),
    };
  }

  clone(): this {
    return new WeeklyScheduleDay(
        this.dayOfWeek,
        this.times.map((e) => e.clone()),
        this.closed,
    ) as this;
  }

  isSame(other: WeeklyScheduleDay): boolean {
    if(other === this) {
      return true;
    }

    return other.dayOfWeek === this.dayOfWeek &&
        other.closed === this.closed &&
        isSameList(other.times, this.times, isSameData);
  }
}

export class WeeklyScheduleDayBuilder extends DataModelBuilder<WeeklyScheduleDay> {
  build(context: SerializationContext, map: SerializedData): WeeklyScheduleDay {
    return WeeklyScheduleDay.fromMap(context, map);
  }
}
